import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '@app/core/api/rest.service';
import { KeyValue, PayloadHotlinePerson, PayloadHotlinePersonResultList } from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestHotlineService extends RestService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchPerson(searchParams: KeyValue<string, any>[]): Observable<PayloadHotlinePersonResultList> {
    const params = this.getKeyValueAsQueryParams(searchParams);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadHotlinePersonResultList>(
        this.baseUrl + '/hotline/suche/person',
        options);
  }

  public getPersonForId(personId: number): Observable<PayloadHotlinePerson> {
    return this.http
      .get<PayloadHotlinePerson>(this.baseUrl + '/hotline/' + personId, this.httpOptions);
  }
}
